<template>
    <v-form>
        <v-text-field
                outlined
                ref="name"
                v-model="$v.document.name.$model"
                label="Document Container Name"
                :error-messages="documentNameError"
                error-count=2
                hint="ie. Driver License"
                required>
        </v-text-field>
        <v-layout >
            <v-flex xs12 sm10 md8 lg6>
                <v-switch label="Document is Required"
                          v-model="document.required">
                </v-switch>
            </v-flex>
            <v-flex xs12 sm10 md8 lg6 mr-2>
                <v-switch label="Document can expire"
                          v-model="document.expired">
                </v-switch>
            </v-flex>
        </v-layout>
        <template v-if="document.expired">
            <v-layout>
                <v-flex>
                    <v-text-field
                            outlined
                            label= "You can pick one or two options below."
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout>

                <v-flex xs12 sm10 md8 lg6 mr-2>
                    <v-text-field
                            outlined
                            label="System Recurring"
                            singel-line
                            solo
                            readonly
                            text
                    >
                    </v-text-field>
                </v-flex>

                <v-flex xs12 sm10 md8 lg6>
                    <v-text-field
                            outlined
                            label="Expired interval"
                            v-mask="documentInterval.textMask"
                            v-model="$v.documentInterval.text.$model"
                            :error-messages="documentExpiredError"
                            hint="ie. 5, 30, 180"
                            :disabled="!document.expired"
                            required>
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm10 md8 lg6>
                    <v-select
                            :items="documentInterval.selectorOptions"
                            :disabled="!document.expired"
                            :value="documentInterval.selected"
                            @change="documentInterval.selected = $event"
                    >
                    </v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs8 sm8 md6 lg4 mr-2>
                    <v-text-field
                            outlined
                            label="User Expired"
                            singel-line
                            solo
                            readonly
                            text
                    >
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm10 md8 lg6>
                    <datePicker :errorFn = "documentUserExpiredError"
                                labelProp="Expired Date"
                                :disabledProp = "!document.expired"
                                @dateValue="$v.documentUserExpired.$model = $event"
                    >
                    </datePicker>
                </v-flex>
            </v-layout>
        </template>
        <v-divider class="mt-5"></v-divider>

        <v-btn  color="primary"
                @click="stpper2Continue">
            Continue
        </v-btn>

        <v-btn text @click="close">
            Cancel
        </v-btn>
    </v-form>
</template>

<script>
    import { required, minLength, maxLength} from 'vuelidate/lib/validators'
    import {DocumentRule} from '../../../shared/dtos/Dtos';
    const datePicker = ()=> import( '@/components/common/DatePicker');

    export default {
        name: "documentRuleDefine",
        components:{
            datePicker
        },
        data(){
            return{
                document: {
                    ...DocumentRule
                },
                documentInterval: {
                    text: '',
                    textMask: '###',
                    selectorOptions:['days', 'months', 'years'],
                    selected: 'days'
                },
                documentUserExpired: ''
            }
        },
        validations: {
            document: {
                name: {
                    required,
                    minLength: minLength(5),
                    unik: function () {
                        let resutl = !this.getDocs.has(this.document.name)
                        return resutl
                    }
                }
            },
            documentInterval: {
                text:{
                    required: required,
                    maxLength: maxLength(3)
                }
            },
            documentUserExpired: {
                required
            }
        },
        computed: {
            documentNameError(){
                const errors = []
                if (!this.$v.document.name.$dirty) {
                    return errors
                }

                !this.$v.document.name.minLength && errors.push('Name must be at least '+
                    this.$v.document.name.$params.minLength.min +' characters long')
                !this.$v.document.name.required && errors.push('Name is required.')
                !this.$v.document.name.unik && errors.push('Document already exist.')
                return errors
            },
            documentExpiredError(){
                const errors = []
                if (!this.$v.documentInterval.text.$dirty || !this.document.expired) {
                    return errors
                }

                if(this.documentUserExpired !== ''){
                    return errors;
                }

                !this.$v.documentInterval.text.maxLength && errors.push('Name must be at max '+
                    this.$v.documentInterval.text.$params.maxLength.max +' characters long')
                !this.$v.documentInterval.text.required && errors.push('A number is required.')
                return errors
            },
            documentUserExpiredError(){
                const errors = []
                if (!this.$v.documentUserExpired.$dirty ||
                    !this.document.expired) {
                    return errors
                }

                if(this.documentInterval.text !== ''){
                    return errors;
                }

                !this.$v.documentUserExpired.required && errors.push('A date is required.')
                return errors
            },
            getDocs(){
                let docsFromStore = this.$store.getters.getDocumentRules;
                let docs =  new Set(docsFromStore.map( elem => {
                    return elem.name;
                }));
                return docs;
            }
        },
        methods:{
            stpper2Continue(){
                this.$v.document.$touch();
                this.$v.documentInterval.$touch();
                this.$v.documentUserExpired.$touch();

                if(this.$v.document.$anyError || (this.document.expired && this.$v.documentInterval.$anyError)){
                    return;
                }
                if(this.document.expired ) {
                    if(this.documentInterval.text !== ''){
                        this.document.expiredInterval = this.documentInterval.text + '-' + this.documentInterval.selected;
                    }
                    if(this.documentUserExpired !== ''){
                        this.document.userExpiredDate = this.documentUserExpired;
                    }
                }

                let docs = this.$store.getters.getDocumentRules;
                docs.push(this.document)

                this.$store.commit('setDocumentRule', this.document)
                this.$store.commit('setDocumentRules', docs)
                this.$emit('stepper', 3);
            },
            close(){
                this.$emit('closeStepper', false)
            }
        }
    }
</script>

<style scoped>

</style>